export default __webpack_public_path__ + "static/media/img-6.39f35e0e.jpg";